import type { ReactNode } from 'react';
import { AuthProvider as BaseAuthProvider } from '@sw/auth';
import { api } from './api-client';

/**
 * Wrapper del AuthProvider de @sw/auth que inyecta el api client del Client Portal.
 * Story SW-311.
 */
export function AuthProvider({ children }: { children: ReactNode }) {
  return <BaseAuthProvider apiClient={api}>{children}</BaseAuthProvider>;
}

// Re-export para que consumers importen desde un solo lugar.
export { useAuth, useLogout, useIdleTimeout } from '@sw/auth';
